import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import Library from '../components/scenes/Library/Library';

import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';

const condition = (authUser) => !!authUser;
const LibraryPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(Library);

export default () => (
  <Layout>
    <LibraryPage />
  </Layout>
);
